import i18nFactory from '@yandex-int/i18n';

import { OrganizationErrorCodes } from '../../declarations/organizations/organizations';
import { createErrorsMapper, ErrorsMatcher, FieldPathMap } from '../ErrorsMapper/ErrorsMapper';

import * as keyset from './OrganizationErrorMappers.i18n';

const i18n = i18nFactory(keyset);

export const organizationErrorMapper = createErrorsMapper<{}>(
    ({ idx }): Array<ErrorsMatcher<{}>> => [
        {
            path: ['adUpdateItems', idx, 'organization'],
            codes: [
                {
                    code: OrganizationErrorCodes.NOT_FOUND,
                    message: (): string => {
                        return i18n('organization-not-found');
                    }
                }
            ]
        }
    ],
    error => ''
);

export const organizationErrorPathMapper = function(index: string): FieldPathMap[] {
    return [
        {
            serverPath: `adUpdateItems.${index}.organization`,
            clientPath: `adUpdateItems.${index}.organization`
        }
    ];
};

export const organizationBannerErrorMapper = createErrorsMapper<{}>(
    ({ idx }): Array<ErrorsMatcher<{}>> => [
        {
            path: ['banners', idx],
            codes: [
                {
                    code: 'BannerDefectIds.Gen.REQUIRED_HREF_OR_VCARD_ID',
                    message: (): string => {
                        return i18n('banner-required-href-turbo-vcard-organization');
                    }
                },
                {
                    code: 'BannerDefectIds.Gen.REQUIRED_HREF_OR_VCARD_ID_OR_TURBO',
                    message: (): string => {
                        return i18n('banner-required-href-turbo-vcard-organization');
                    }
                }
            ]
        }
    ],
    error => ''
);

export const organizationBannerErrorPathMapper = function(index: string): FieldPathMap[] {
    return [
        {
            serverPath: `adUpdateItems`,
            clientPath: `banners`
        },
        {
            serverPath: `adUpdateItems.${index}`,
            clientPath: `banners.${index}`
        }
    ];
};
